<template>
  <div>
    <b-form-input
      ref="linkButton"
      v-model="displayValue"
      readonly
      @focus="showPopover = true"
      :state="state"
    />
    <b-popover
      :show.sync="showPopover"
      :target="popoverTarget"
      placement="bottom"
      triggers="focus"
    >
      <template #title>
        <div class="d-flex justify-content-between align-items-center">
          <b-button @click="previousYear">
            <b-icon icon="chevron-left" variant="primary"></b-icon>
          </b-button>
          <p class="mb-0">{{ selectedYear }}</p>
          <b-button @click="nextYear">
            <b-icon icon="chevron-right" variant="primary"></b-icon>
          </b-button>
        </div>
      </template>
      <b-row>
        <b-col
          v-for="date in calendarDates"
          :key="date.value"
          cols="4"
          class="mb-4 text-center"
        >
          <b-button
            @click="selectDate(date.value)"
            class="w-100 border p-3"
            :class="{
              'bg-primary': date.isEnabled && isSelected(date.value),
              'text-white': date.isEnabled && isSelected(date.value),
            }"
            :style="{
              cursor: date.isEnabled ? undefined : 'not-allowed',
            }"
            :disabled="!date.isEnabled"
          >
            <p class="mb-0">{{ date.title }}</p>
          </b-button>
        </b-col>
      </b-row>
    </b-popover>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "MonthYearPickerInput",
  model: {
    prop: "modelValue",
    event: "update:modelValue",
  },
  props: {
    modelValue: String,
    min: String,
    max: String,
    state: Object,
  },
  emits: ["update:modelValue"],
  data() {
    const year = this.modelValue?.split("-")[0] || moment().year();
    return {
      selectedYear: parseInt(year.toString()),
      popoverTarget: null,
      showPopover: false,
    };
  },
  mounted() {
    this.popoverTarget = this.$refs.linkButton;
  },
  computed: {
    displayValue() {
      if (!this.modelValue) return "";
      const [year, month] = this.modelValue.split("-");
      return `${month}/${year}`;
    },
    calendarDates() {
      const items = [];
      const inicio = moment({ year: this.selectedYear });
      while (inicio.year() === this.selectedYear) {
        let isEnabled = true;
        if (isEnabled && this.min) {
          isEnabled = inicio.isSameOrAfter(this.min);
        }
        if (isEnabled && this.max) {
          isEnabled = inicio.isSameOrBefore(this.max);
        }
        items.push({
          title: inicio.locale("pt-BR").format("MMM"),
          value: inicio.format("yyyy-MM"),
          isEnabled,
        });
        inicio.add(1, "month");
      }
      return items;
    },
  },
  methods: {
    nextYear() {
      this.selectedYear++;
    },
    previousYear() {
      this.selectedYear--;
    },
    isSelected(date) {
      if (!this.modelValue) return false;
      const [year, month] = date.split("-");
      const [selectedYear, selectedMonth] = this.modelValue.split("-");
      return selectedMonth == month && selectedYear == year;
    },
    selectDate(date) {
      const [year, month] = date.split("-");
      const newDate = `${year}-${month}`;
      this.$emit("update:modelValue", newDate);
      this.showPopover = false;
    },
  },
};
</script>
